/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdTabsProps, TdTabPanelProps } from './type';

export const tabsDefaultProps: TdTabsProps = {
  bottomLineMode: 'fixed',
  showBottomLine: true,
  size: 'medium',
  spaceEvenly: true,
  sticky: false,
  swipeable: true,
  theme: 'line',
};

export const tabPanelDefaultProps: TdTabPanelProps = { destroyOnHide: true, disabled: false, lazy: false };
